/**
 * Permission slugs mirroring the backend seeds/permissions.js
 * Used for client-side permission checks (sidebar visibility, route guards).
 */
export const PERMISSIONS = {
  MANAGE_SITE_SETTINGS: "manage_site_settings",
  MANAGE_USERS: "manage_users",
  MANAGE_LISTINGS: "manage_listings",
  MANAGE_LISTING_REQUESTS: "manage_listing_requests",
  MANAGE_RESERVATIONS: "manage_reservations",
  MANAGE_USER_REVIEWS: "manage_user_reviews",
  MANAGE_ADMIN_REVIEWS: "manage_admin_reviews",
  MANAGE_SITE_SERVICE_FEE: "manage_site_service_fee",
  MANAGE_SITE_VAT: "manage_site_vat",
  MANAGE_SITE_COMMISSION_FEE: "manage_site_commission_fee",
  MANAGE_SITE_FEES: "manage_site_fees",
  VIEW_USER_MESSAGES: "view_user_messages",
  MANAGE_SEARCH_SETTINGS: "manage_search_settings",
  MANAGE_POPULAR_LOCATIONS: "manage_popular_locations",
  MANAGE_CMS_PAGES: "manage_cms_pages",
  MANAGE_PAYOUT: "manage_payout",
  CANCELLATION_POLICY_MANAGEMENT: "cancellation_policy_management",
  MANAGE_PAYMENT_GATEWAY: "manage_payment_gateway",
  MANAGE_USER_DOCUMENT_VERIFICATION: "manage_user_document_verification",
  MANAGE_USER_REPORTS: "manage_user_reports",
  MANAGE_HOME_PAGE_BANNERS: "manage_home_page_banners",
  MANAGE_LISTING_SETTINGS: "manage_listing_settings",
  MANAGE_WHY_BECOME_HOST_PAGE: "manage_why_become_host_page",
  MANAGE_CONFIGURATION_SETTINGS: "manage_configuration_settings",
  MANAGE_WHY_HOST_PAGE: "manage_why_host_page",
  MANAGE_INQUIRY: "manage_inquiry",
  MANAGE_CURRENCY: "manage_currency",
  MANAGE_MANAGED_BY_GHORFATECH: "manage_managed_by_ghorfatech",
  MANAGE_ADMIN_ROLES: "manage_admin_roles",
  MANAGE_ADMIN_USERS: "manage_admin_users",
  MANAGE_COUPONS: "manage_coupons",
  MANAGE_TICKETS: "manage_tickets",
  MANAGE_CHAT: "manage_chat",

  // View-only permissions (read access without write/edit/delete)
  VIEW_LISTINGS: "view_listings",
  VIEW_RESERVATIONS: "view_reservations",
  VIEW_USERS: "view_users",
  VIEW_USER_REVIEWS: "view_user_reviews",
  VIEW_OTP: "view_otp",
};

/**
 * The "super admin" role name — super admins bypass all permission checks.
 */
export const SUPER_ADMIN_ROLE = "super admin";
